import { ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import styles from './stacked-bar-label-icons.module.scss';
import clsx from 'clsx';
import { IconTooltip } from 'components/molecules/icon-tooltip/IconTooltip';

const StackedBarLabelIcons = () => {
  return (
    <div
      className={clsx(styles.StackedBarLabelIcons)}
      style={{
        paddingRight: 15,
        paddingLeft: 15,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      }}
    >
      <IconTooltip iconSize='24' icon={ICONS_ENUM.MAPS_TRAIN} />
      <IconTooltip icon={ICONS_ENUM.SI_ICONS_EDUCATION} />
      <IconTooltip icon={ICONS_ENUM.DEVICE_AIRPLANEMODE_ACTIVE} />
      <IconTooltip icon={ICONS_ENUM.MAPS_HOTEL} />
      <IconTooltip icon={ICONS_ENUM.EDITOR_MONETIZATION_ON} />
    </div>
  );
};

export default StackedBarLabelIcons;
